// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin › Service providers list and its add/edit dialogs. */

.service-providers-page__person {
  display: inline-flex;
  align-items: center;
  gap: var(--ds-space-2);
  min-width: 0;
}

.service-providers-page__person .ant-avatar,
.service-providers-page__logo.ant-avatar {
  flex-shrink: 0;
}

.service-providers-page__logo.ant-avatar img {
  object-fit: contain;
}

.service-providers-page__status {
  min-width: 120px;
}
`, "",{"version":3,"sources":["webpack://./src/admin/components/serviceProviders/ServiceProviders.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* Admin › Service providers list and its add/edit dialogs. */\n\n.service-providers-page__person {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  min-width: 0;\n}\n\n.service-providers-page__person .ant-avatar,\n.service-providers-page__logo.ant-avatar {\n  flex-shrink: 0;\n}\n\n.service-providers-page__logo.ant-avatar img {\n  object-fit: contain;\n}\n\n.service-providers-page__status {\n  min-width: 120px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
